<template>
<a name="Bulletionnnn">
    <lazy-component @show.once="render(false)">
      <div v-if="isShow">
        <Module ref="Module" class="anView"
        :title="'公告'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :checkData="checkData"
        :showMore="showMore"
        :emptyTitle="'暂无公告信息'"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">
              <div v-for="(item, index) in slotProps.list"
              :key="index"
              @click="clickCell(item, index)"
              class="announcement">
              <p class="announcement-text">{{item.title}}</p>
              <div class="announcement-info">
                <!-- <span class="announcement-tag">公告</span> -->
                <span class="announcement-source">{{item.source}}</span>
                <span class="announcement-time">{{getTime(item)}}</span>
              </div>
          </div>
        </div>
        </Module>
      </div>
    </lazy-component>
</a>
</template>

<script>
import Util from '@/base/Util';
// import dataModel from '@/model/announcement.model';
import StoreManger from '@/utils/FundHQJHManger';
import Module from '@/components/ModuleChoose.vue';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundAnnouncement',
  components: {
    Module,
  },
  data() {
    return {
      isShow: true,
      pageData: [],
      nativeData: {},
      fundCode: '',
      fundType: '',
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    show() {
      this.isShow = true;
      return this.isShow;
    },
    render(iscache) {
      if (this.show()) {
        this.nativeData = this.$store.state.native.fund;
        this.fundCode = this.nativeData.fundCode;
        this.fundType = this.nativeData.fundType;
        this.$nextTick(() => {
          if (iscache) {
            this.$refs.Module.cache();
          } else {
            this.$refs.Module.start();
          }
        });
      }
    },
    fetchCache() {
      return this.$store.state.announcement.fund[this.fundCode];
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateAnn', this.fundCode)
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    showMore(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 1);
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    getTime(item) {
      // const res = Util.formatTimeString(item.time);
      const res = Util.getGGDateFormat(item.time);
      return res;
    },
    clickCell(item, index) {
      detailPushPage({
        type: 2,
        url: `${item.url}?noticeid=${item.id}&id=${this.fundCode}`,
      });
      this.reportMonitor({
        eventName: `pz.xx.gg.${index}`,
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '7be9fe8d23404e658637288726244df5',
        url: '/pages/optionalNews',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          index: 2,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.gg.more',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
  },
};
</script>

<style scoped lang="less">
.anView{
  border-radius: 12px;
}
.announcement {
  background-color: #ffffff;
  margin-left: 24px;
  padding-top: 24px;
  padding-bottom: 24px;
  margin-right: 24px;
  &:nth-last-child(1) {
    &:after{
      display: none;
    }
  }

  &-text {
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #000000;
    text-align: left;
    line-height: 1.7;
  }

  &-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
  }

  &-tag {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #ff6434;
    line-height: 20px;
    padding: 4px 6px;
    border-radius: 4px;
    background-color: #fff1ec;
  }

  &-source {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
    margin-right: 16px;
  }

  &-time {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
  }
}
</style>
